<template>
  <div class="lawCard">
    <div class="card_item flex_start" v-if="isudflo">
      <div><img src="../../../assets/laws/defaultrt.png" alt="" /></div>
      <div>
        <div class="cardtil">律师入驻</div>
        <div class="phone">400-000-0000</div>
      </div>
    </div>
    <div class="card_item flex_start" v-else>
      <div><img src="../../../assets/laws/samllrt_sample.png" alt="" /></div>
      <div>
        <div class="cardtil">XX律师</div>
        <div class="dec">刑事纠纷、房产纠纷</div>
        <div class="phone">188 5555 5555</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        isudflo:{
            type:Boolean,
            default:false
        }
    }
};
</script>

<style lang="scss" scope>
.lawCard {
  width: 100%;
  .card_item {
    width: 100%;
    height: 100px;
    padding-left: 23px;
    font-size: 16px;
    color: #333333;
    text-align: left;
    background: url("../../../assets/laws/rz_bg.png") no-repeat 100% 100%;
    img {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .cardtil {
      margin-bottom: 6px;
    }
    .dec {
      font-size: 12px;
      color: #999999;
    }
    .phone {
      margin-top: 8px;
      padding-left: 8px;
      line-height: 14px;
      border-left: 3px solid #0465ea;
    }
  }
}
</style>